
var idResize; //for resize-timer

let currentSection = 0;

const onDistanceScrolledResetAos = (distance = 5000) => {
    if (typeof(AOS) != "undefined" && AOS) {

        var calculateSection = parseInt(jQuery(window).scrollTop() / distance, 10);
        // console.debug("currentSection", currentSection, calculateSection)
        if (currentSection !== calculateSection) {
            currentSection = calculateSection;
            // console.log("refreshing AOS!");
            AOS.refresh();
        }
        return true;
    } else {
        return false;
    }

}

const handleFirstBlockAnimation = (firstBlockPreheadline, firstBlockHeadline, firstBlockFulltext, firstBlockButtonContainer) =>
{
    const HeaderContent = {
        1: {
            content: firstBlockPreheadline,
            nextElement: firstBlockHeadline,
            prevElement: null
        },
        2: {
            content: firstBlockHeadline,
            nextElement: firstBlockFulltext,
            prevElement: firstBlockPreheadline
        },
        3: {
            content: firstBlockFulltext,
            nextElement: firstBlockButtonContainer,
            prevElement: firstBlockHeadline
        },
        4: {
            content: firstBlockButtonContainer,
            nextElement: null,
            prevElement: firstBlockFulltext
        },
    }
    Object.keys(HeaderContent).map((key) =>
    {
        if (HeaderContent[key].prevElement != null)
        {
            //will be animated from parrent
            if (HeaderContent[key].content.length == 0)
            {
                //get first elem in chain that was triggerd
                let prevElement = HeaderContent[key].prevElement;
                while (prevElement)
                {
                    if (prevElement.length > 0)
                    {
                        break;
                    }
                    prevElement = prevElement.prevElement;
                }
                if (typeof (prevElement) != "undefined" && prevElement.length > 0)
                {
                    prevElement.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
                        function (e)
                        {
                            //animate next element when he is done animating
                            jQuery(HeaderContent[key].nextElement).addClass("zw-animate");
                        }
                    );
                } else
                {
                    jQuery(HeaderContent[key].nextElement).addClass("zw-animate");
                }
            } else
            {
                jQuery(HeaderContent[key].content).one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
                    function (e)
                    {
                        //animate next element when he is done animating
                        jQuery(HeaderContent[key].nextElement).addClass("zw-animate");
                    }
                );
            }
        } else if (HeaderContent[key].content.length > 0 && typeof (HeaderContent[key].content) != "undefined")
        {
            jQuery(HeaderContent[key].content).addClass("zw-animate");
            jQuery(HeaderContent[key].content).one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
                function (e)
                {
                    //animate next element when he is done animating
                    jQuery(HeaderContent[key].nextElement).addClass("zw-animate");
                }
            );
        }
    });

}

const createClassStringFromItemsObject = (items = {}, classString = "") =>
{
    let i = 1;
    Object.keys(items).map((key) =>
    {
        if (items[key].length > 0)
        {
            let j = 1;
            items[key].map((item) =>
            {
                let keyClassName = key;
                let itemClassName = item;
                if (key[0] == ".")
                {
                    //remove .
                    keyClassName = keyClassName.substring(1);
                }
                if (item[0] == ".")
                {
                    //remove .
                    itemClassName = itemClassName.substring(1);
                }
                classString += "." + keyClassName + " " + "." + itemClassName;
                if (j < items[key].length || i < Object.keys(items).length)
                {
                    classString += ", ";
                }
                j++;
            })
        } else
        {
            let keyClassName = key;
            if (key[0] == ".")
            {
                //remove .
                keyClassName = keyClassName.substring(1);
            }
            classString += "." + keyClassName;
            if (i != Object.keys(items).length)
            {
                classString += ", ";
            }
        }
        i++;
    });
    return classString;
}

// Grid animations (Impressions Block)
function animateGridItems(classString = "")
{
    const gridItems = document.querySelectorAll(".zw-cgb__impressions .g-item");
    const animations = ["fade-left", "fade-right", "fade-up", "fade-down", "zoom-in", "zoom-out", "flip-left", "flip-right"];

    gridItems.forEach((item, index) =>
    {
        let animation = animations[index % animations.length];
        item.setAttribute("data-aos", animation);
        item.setAttribute("data-aos-duration", "650");
        item.setAttribute("data-aos-offset", "100");
    });
}

// Image animations
function animateBcardBlocks(classString = "")
{
    document.querySelectorAll(".zw-cgb__bcard-block .row").forEach(row =>
    {
        const imageCol = row.querySelector(".zw-cgb__image-col");
        const contentCol = row.querySelector(".zw-cgb__content-col");

        if (imageCol && contentCol)
        {
            const isImageLeft = imageCol.classList.contains("col-md-4");

            imageCol.setAttribute("data-aos", isImageLeft ? "fade-left" : "fade-right");
            contentCol.setAttribute("data-aos", isImageLeft ? "fade-right" : "fade-left");

            imageCol.setAttribute("data-aos-duration", "650");
            imageCol.setAttribute("data-aos-offset", "100");
            contentCol.setAttribute("data-aos-duration", "650");
            contentCol.setAttribute("data-aos-offset", "100");
        }
    });
}

// Method to disable AOS on elements inside the next sibling
function disableAOSOnNextSibling(siblingSelector)
{
    document.querySelectorAll(siblingSelector).forEach(el =>
    {
        const next = el.nextElementSibling;

        if (next)
        {
            next.querySelectorAll('[data-aos]').forEach(child =>
            {
                child.removeAttribute('data-aos');
                child.removeAttribute('data-aos-delay');
                child.removeAttribute('data-aos-duration');
            });
        }
    });
}

jQuery(document).ready(function ()
{
    window.setTimeout(() =>
    {

        //AOS animations initializations over data atts
        // document.dispatchEvent(new Event('zw-aos-jQuery'));
        if (typeof (AOS) != "undefined" && AOS)
        {
            //class names arragend in object hyerarchy not to be animated !!!
            const allClasses = [
                "zw-cgb__headline",
                "zw-cgb__preheadline",
                "zw-cgb__fulltext",
                "btn",
                "team-member-phone",
                "team-member-icon-container",
                "text-normal",
                "text-small",
                "zitat-text",
                "content-container",
                "atr-icon",
                "zw-video-container",
                "bg-image",
                "content-col-image-row",
                "image-container",
                "bg-img-container",
                "img-container",
                "respnsive-img",
                "inner-container",
                "wp-block-spacer",
                "zw-spacer",
                "image",
                "list-content",
                "list-counter",

                "zw-cgb__subheadline",
                "zw-cgb__btn",
                "zw-cgb__social-media-icon",
                "postTitle",
                "zw-cgb__subfooter",
                "zw-cgb__image-col",
                "videoEmbedBlock",
                "zw-cgb__impressions",
                "calltoaction",
                "zw-cgb__galleryslider",
                "latestPosts",
                "zw-headline-image-block",
                "global-widget.center .inner-container"
            ];
            const itemsToNotAnimate = {
                "akkordion700": [...allClasses],
                "zitat-text": [...allClasses],
                "main-header": [...allClasses],
                "is-first-block": [...allClasses],
                "footer": [...allClasses],
                // "latestPosts": [...allClasses],
                "columnmaster020 .no-image-layout": [...allClasses],
                "global-widget .inner-container": [...allClasses],
                "global-widget.center .inner-container": [...allClasses],
                "show-cookie-box": [...allClasses],
                "zitat-row": [
                    "zitat-name-container",
                    "zitat-discription-container"
                ],
                "team-member-content": [
                    "team-member-name",
                    "team-member-description"
                ],
                "is-first-block":[],
                "is-first-block": [...allClasses],
                ".td.button": [...allClasses],
                ".pagination": [...allClasses],
                "title-wrapper": [...allClasses],
                "subfooter-sidebar": [...allClasses],
            }
            let items = {};
            items = {
                "zw-cgb__headline": [],
                "zw-cgb__preheadline": [],
                "zw-cgb__fulltext": [],
                "text-normal": [],
                "text-small": [],
                "atr-icon": [],
                "btn": [],
                "list-counter": [],
                "global-widget.center .inner-container": [],
                "zw-video-container": [],
                "zw-cgb__subheadline": [],
                "zw-cgb__btn": [],
                "zw-cgb__social-media-icon": []
            }
            // const contentElFadedUp = ".zw-cgb__headline, .zw-cgb__preheadline, .zw-cgb__fulltext, .text-normal, .text-small, .atr-icon, .btn, .list-counter, .global-widget.center .inner-container, .zw-video-container"
            const contentElFadedUp = createClassStringFromItemsObject(items)
            items = {
                "text-normal": [],
                "text-small": [],
                "postTitle": [],
                "zw-cgb__subfooter": []
            }
            const contentElFadedDown = createClassStringFromItemsObject(items)
            items = {
                "single-slide-item.content-left": [
                    "zw-cgb__headline",
                    "zw-cgb__preheadline",
                    "zw-cgb__fulltext",
                    "btn",
                ]
            }
            // const contentTypeSliderLeftContent = ".single-slide-item.content-left .zw-cgb__headline, .single-slide-item.content-left .zw-cgb__preheadline, .single-slide-item.content-left .zw-cgb__fulltext, .single-slide-item.content-left .btn";
            const contentTypeSliderLeftContent = createClassStringFromItemsObject(items)
            items = {
                "single-slide-item.content-right": [
                    "zw-cgb__headline",
                    "zw-cgb__preheadline",
                    "zw-cgb__fulltext",
                    "btn",
                ]
            }
            // const contentTypeSliderRightContent = ".single-slide-item.content-right .zw-cgb__headline, .single-slide-item.content-right .zw-cgb__preheadline, .single-slide-item.content-right .zw-cgb__fulltext, .single-slide-item.content-right .btn";
            const contentTypeSliderRightContent = createClassStringFromItemsObject(items)

            items = {
                "global-widget.right": [
                    "inner-container"
                ],
                "zitat-text": [],
                "zw-video-container": [],
                "zw-cgb__image-col": [],
                "videoEmbedBlock": [],
                "zw-cgb__impressions": [],
                "calltoaction": []
            }
            const contentElFadedLeft = createClassStringFromItemsObject(items)
            items = {
                "global-widget.left": [
                    "inner-container"
                ],
                // "zw-cgb__galleryslider .wp-block-gallery": [],
                "latestPosts": [],
                "zw-headline-image-block": [],
                "global-widget.center .inner-container": [],
                "clubMagazineItem": [],
            }
            const contentElFadedRight = createClassStringFromItemsObject(items)
            items = {
                "wp-block-spacer": [],
                "zw-spacer": [],
            }
            const contentElZoomedOut = "";
            // const contentElZoomedOut = ".wp-block-spacer, .zw-spacer";

            //header animations is connected with bodyAnimactions scss
            const firstBlockPreheadline = jQuery(".is-first-block .zw-cgb__preheadline").not(jQuery('.header-standard-block .zw-cgb__preheadline'));
            const firstBlockHeadline = jQuery(".is-first-block .zw-cgb__headline").not(jQuery('.header-standard-block .zw-cgb__headline'));
            const firstBlockFulltext = jQuery(".is-first-block .zw-cgb__fulltext").not(jQuery('.header-standard-block .zw-cgb__fulltext'));
            const firstBlockButtonContainer = jQuery(".is-first-block .zw-cgb-button-container").not(jQuery('.header-standard-block .zw-cgb-button-container'));
            //animate firstBlock
            // handleFirstBlockAnimation(firstBlockPreheadline, firstBlockHeadline, firstBlockFulltext, firstBlockButtonContainer);
            //animate body
            let classString = createClassStringFromItemsObject(itemsToNotAnimate);
            jQuery(contentElFadedLeft).not(jQuery(classString)).not('.is-first-block').attr("data-aos", "fade-left").attr("data-aos-duration", "650").attr("data-aos-offset", 320);
            jQuery(contentElFadedRight).not(jQuery(classString)).not('.is-first-block').attr("data-aos", "fade-right").attr("data-aos-duration", "650").attr("data-aos-offset", 320);
            jQuery(contentElZoomedOut).not(jQuery(classString)).not('.is-first-block').attr("data-aos", "zoom-out").attr("data-aos-offset", 100);
            jQuery(contentElFadedUp).not(jQuery(classString)).not('.is-first-block').attr("data-aos", "fade-up").attr("data-aos-duration", "650").attr("data-aos-offset", 100);
            jQuery(contentElFadedDown).not(jQuery(classString)).not('.is-first-block').attr("data-aos", "fade-down").attr("data-aos-duration", "650").attr("data-aos-offset", 100);
            //content from left list from right
            jQuery(contentTypeSliderLeftContent).attr("data-aos", "fade-left").attr("data-aos-duration", "650").attr("data-aos-offset", 245);
            // jQuery(contentTypeListSliderLeftList).attr("data-aos", "fade-left").attr("data-aos-duration", "650").attr("data-aos-offset", 320);
            //content from right list from left
            jQuery(contentTypeSliderRightContent).attr("data-aos", "fade-left").attr("data-aos-duration", "650").attr("data-aos-offset", 245);
            // jQuery(contentTypeListSliderRightList).attr("data-aos", "fade-right").attr("data-aos-duration", "650").attr("data-aos-offset", 320);

            //change animation on InfoBlock before zitat block
            const infoBlocks = jQuery('.infoblock ');
            Object.keys(infoBlocks).map((position) =>
            {
                if (jQuery(infoBlocks[position]).next('.zitat-block').length > 0)
                {
                    //there is a sibling with a class zitat-block
                    jQuery(infoBlocks[position]).addClass('faded-left')
                }
            })

            items = {
                "animation-X": [
                    ...allClasses
                ]
            }

            const cancleAnimations = createClassStringFromItemsObject(items);

            if (jQuery(cancleAnimations).length > 0)
            {
                // console.log("removing animations !!! ")
                jQuery(cancleAnimations).removeAttr("data-aos").removeAttr("data-aos-duration").removeAttr("data-aos-offset").removeClass('aos-init').removeClass('aos-animate');
            }

            // Execute AADEV ANIMATIONS
            animateGridItems(classString);
            animateBcardBlocks(classString);
            AOS.init({
                startEvent: 'zw-aos-event', // name of the event dispatched on the document, that AOS should initialize on
                once: true, // whether animation should happen only once - while scrolling down
                mirror: false, // whether elements should animate out while scrolling past them
                // offset: -800, // offset (in px) from the original trigger point
            })

            document.dispatchEvent(new Event('zw-aos-event'));
            disableAOSOnNextSibling('.zw-cgb__000.is-first-block');
        } else
        {
            //remove header animation
            const animatedBlocks = jQuery(".is-first-block .zw-cgb__preheadline, .is-first-block .zw-cgb__headline, .is-first-block .zw-cgb__fulltext, .is-first-block .zw-cgb-button-container");
            jQuery(animatedBlocks).addClass("zw-prevent-animation");
        }

    }, 0);

    setTimeout(() =>
    {
        // Disconnect observer after AOS refreshe
        if (zwAosOBodyObserver)
        {
            // console.debug("disconnecting zwAosOBodyObserver");
            zwAosOBodyObserver.disconnect();
        }
    }, 10000);
});
const zwAosOBodyObserver = new MutationObserver(() =>
{
    requestAnimationFrame(() =>
    {
        setTimeout(() =>
        {
            if (typeof (AOS) != "undefined" && AOS)
            {
                if (document.body.classList.contains('admin-bar'))
                {
                    // Body has admin-bar class
                    // console.debug('zwAosOBodyObserver Admin bar detected, refresh AOS');
                    AOS.refresh();
                }
            }
        }, 100);
    });
});
zwAosOBodyObserver.observe(document.body, { childList: true, subtree: true, });




